import script from "./record-check.vue?vue&type=script&setup=true&lang=js"
export * from "./record-check.vue?vue&type=script&setup=true&lang=js"

import "./record-check.vue?vue&type=style&index=0&id=5a89f67c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a89f67c"]])

export default __exports__